import { LanguageKeyType } from 'types';

export const DEFAULT_LANGUAGE: LanguageKeyType = 'pl';
